import type { ClassData, Library, LibraryData } from '@/core/types/library.type'

import { isTypeDef } from '../isTypeDef'
import { getLibraryStoreKey } from '../libraries/getLibraryStoreKey'
import { normalizeRuntimeName } from '../runtime/normalizeRuntimeName'

import { getLibraryPayloadMetadata } from './getLibraryPayloadMetadata'
import { mapClass } from './mapClass'
import { mapGlobalLibraryEntries } from './mapGlobalLibraryEntries'

export const mapLibrary = (item: Library): LibraryData => {
  const { members, name, namespace, version, runtimeVersion } = getLibraryPayloadMetadata(item.payload)
  const classes = members.filter(isTypeDef).map(mapClass)
  const classEntries: Array<[string, ClassData]> = classes.map((classData, index) => [
    `${classData.name}-${index}`,
    classData,
  ])
  classEntries.push(...mapGlobalLibraryEntries(members))

  return {
    id: getLibraryStoreKey(item.runtimeName, name),
    name,
    namespace,
    version,
    runtimeName: normalizeRuntimeName(item.runtimeName),
    runtimeVersion,
    classes: Object.fromEntries(classEntries),
  }
}
